import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayOPEEnum} from "./GatewayOPEEnum";

class GatewayDTO {
  id!: number;
  name!: string;
  macAddress?: string;
  online!: boolean;
  status!: string;
}

/**
 * O Inner Class
 */
class O {
  gateways!: GatewayDTO[];
}

/**
 * I Inner Class
 */
class I {

}

export class GetFlashedGatewaysCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(GatewayOPEEnum.GetFlashedGateways);
    this.i = new I();
    this.o = new O();
  }
}
